var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaPaymentCard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 35,
    viewBox: "0 0 53 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 5h52v25H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.005 30L52 31a4 4 0 01-4 3.998L4 35a4 4 0 01-4-4v-1h52.005z",
    fill: "#F7B600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5V4a4 4 0 014-4h44.005a4 4 0 014 4v1H0zM20.59 11.196l-5.373 12.608H11.7l-2.654-10.06c-.133-.588-.332-.85-.796-1.11-.796-.393-2.123-.85-3.251-1.046l.066-.392h5.64c.73 0 1.393.457 1.525 1.306l1.394 7.317 3.45-8.558h3.516v-.065zm13.734 8.492c0-3.331-4.644-3.527-4.644-4.964 0-.458.464-.915 1.393-1.046.464-.065 1.791-.13 3.25.588l.598-2.678c-.796-.261-1.791-.588-3.118-.588-3.251 0-5.573 1.698-5.573 4.18 0 1.83 1.658 2.81 2.919 3.398 1.26.588 1.725.98 1.725 1.568 0 .849-.995 1.24-1.99 1.24-1.66 0-2.654-.456-3.384-.783l-.597 2.744c.796.326 2.19.653 3.649.653 3.45 0 5.705-1.698 5.772-4.312zm8.624 4.116H46l-2.654-12.608h-2.852c-.664 0-1.195.392-1.394.915l-4.975 11.693h3.45l.663-1.894h4.246l.464 1.894zm-3.715-4.442l1.725-4.704.995 4.704h-2.72zm-13.932-8.166l-2.72 12.608h-3.317l2.72-12.608H25.3z",
    fill: "#1A1F71"
  })));
}

export default SvgVisaPaymentCard;